import React from "react";
import slider1 from "../assets/images/login-image.gif";

function LoginSidebar() {
  return (
    <>
      <div className="auth-bg   pt-5   ">
        <div className="auth-center">
          <div className="bg-overlay   " />
          <ul className="bg-bubbles">
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
          </ul>

          <div className="row justify-content-center align-items-center my-auto">
            <div className="col-xl-12">
              <div className="sliderimage">
                <img src={slider1} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default LoginSidebar;
